var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app',{staticStyle:{"background-color":"black","height":"100vh"}},[_c('img',{staticClass:"imageClassMobile",attrs:{"src":require("@/assets/4.jpg")},on:{"click":_vm.openMyMed}}),_c('img',{staticClass:"imageClassDesktop",attrs:{"src":require("@/assets/Desktop_Banner_welcome.png")}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }